<template>
  <div>
    <div class="searchArea">
      <a-input v-model:value="searchName" placeholder="请输入促销品类名称" style="width: 300px; margin-right: 10px;" @pressEnter="search" />
      <a-button type="primary" shape="circle" @click="search()">
        <template #icon>
          <SearchOutlined /></template>
      </a-button>
      <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>

      <a-button type="primary" style="margin-left: 20px" @click="showAddModal">
        <template #icon>
          <PlusOutlined /></template>
        新增促销品类
      </a-button>
    </div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :pagination="{ pageSize: 12 }">
      <template #imageUuid="{ record }">
        <div v-if="record.imageUuid" class="thumbnail-wrapper">
          <a-image :src="imageUrl + record.imageUuid" :width="50" :height="50" style="object-fit: cover; border-radius: 4px;" alt="缩略图" />
        </div>
        <span v-else>无图片</span>
      </template>

      <template #operation="{ record, index }">
        <div class="flex_sa">
          <a @click="moveRow(index, -1)" :class="{ 'is-disabled': index === 0 }" style="margin-right: 8px;">
            <ArrowUpOutlined />
          </a>
          <a @click="moveRow(index, 1)" :class="{ 'is-disabled': index === data.length - 1 }" style="margin-right: 8px;">
            <ArrowDownOutlined />
          </a>

          <a-tooltip title="编辑">
            <a @click="showEditModal(record)">
              <FormOutlined />
            </a>
          </a-tooltip>

          <a-popconfirm title="确定要删除此促销品类吗？" @confirm="handleDelete(record.id)">
            <a-tooltip title="删除" style="margin-left: 8px;">
              <a class="text_danger">
                <DeleteOutlined />
              </a>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </a-table>

    <PromoTypeModal v-model:visible="addVisible" :record="{}" :categoryName="CATEGORY_NAME" :categoryType="CATEGORY_TYPE" @ok="handleSuccess" />
    <PromoTypeModal v-model:visible="editVisible" :record="selectedRecord" :categoryName="CATEGORY_NAME" :categoryType="CATEGORY_TYPE" @ok="handleSuccess" />
  </div>
</template>

<script>
import { SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
// 导入 API 接口，你需要根据实际项目结构创建或修改这些接口
// 假设这些接口可以复用：
import { GetCategoryList, DeleteCategory, SaveCategoryOrder } from "/src/api/shopping.js";
import PromoTypeModal from "../../components/shopping/PromoTypeModal.vue"; // 引入模态框组件

export default {
  name: "促销品类管理",
  components: {
    SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined,
    ArrowUpOutlined, ArrowDownOutlined,
    PromoTypeModal, // 注册模态框组件
  },
  data() {
    return {
      searchName: undefined,
      data: [],
      addVisible: false,
      editVisible: false,
      selectedRecord: {},

      // *** 关键参数：根据接口文档设置 ***
      CATEGORY_NAME: '促销品类', // 对应接口文档中的 name
      CATEGORY_TYPE: '商城设置', // 对应接口文档中的 category
      // **********************************

      imageUrl: '/api/file/img/', // 图片前缀
      columns: [
        { title: "名称", dataIndex: "value", key: "value", width: "30%" },
        {
          title: "图片",
          dataIndex: "imageUuid",
          key: "imageUuid",
          width: "15%",
          slots: { customRender: "imageUuid" }
        },
        { title: "顺序", dataIndex: "orderIndex", key: "orderIndex", width: "10%" },
        { title: "操作", key: "operation", width: "25%", slots: { customRender: "operation" } },
      ],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    // 列表查询
    async search() {
      let params = {
        category: this.CATEGORY_TYPE,
        name: this.CATEGORY_NAME,
        value: this.searchName,
      };

      try {
        const res = await GetCategoryList(params);
        if (res.errCode === 0) {
          // 关键：在获取数据时，前端手动添加序号
          this.data = res.data.map((item, index) => ({
            ...item,
            orderIndex: index + 1 // 确保每行都有序号显示
          }));
        } else {
          message.error(res.errMsg || "查询失败");
        }
      } catch (error) {
        console.error("Search error:", error);
        message.error("请求异常，请稍后重试");
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchName = undefined;
      this.search();
    },

    // 显示新增模态框
    showAddModal() {
      this.addVisible = true;
    },
    // 显示编辑模态框
    showEditModal(record) {
      // 传递数据时必须使用对象展开创建副本，防止直接修改表格数据
      this.selectedRecord = { ...record };
      this.editVisible = true;
    },

    // 模态框成功回调：执行刷新列表
    handleSuccess() {
      this.search();
    },

    // 删除操作
    async handleDelete(id) {
      try {
        const res = await DeleteCategory({ id: id });
        if (res.errCode === 0) {
          message.success("删除成功");
          this.search();
        } else {
          message.error(res.errMsg || "删除失败");
        }
      } catch (error) {
        console.error("Delete error:", error);
        message.error("请求异常，请稍后重试");
      }
    },

    // 1. 行数据上移/下移 (逻辑与原代码保持一致)
    moveRow(index, direction) {
      const targetIndex = index + direction;

      if (targetIndex < 0 || targetIndex >= this.data.length) {
        return;
      }

      // 交换数组元素
      const temp = this.data[index];
      this.data.splice(index, 1);
      this.data.splice(targetIndex, 0, temp);

      // 重新计算并更新 '顺序' 字段
      this.data.forEach((item, idx) => {
        item.orderIndex = idx + 1;
      });

      this.saveRowOrder(); // 异步保存新顺序
    },

    // 2. 保存新的行顺序到后端 API
    async saveRowOrder() {
      // 提取所有数据的 id 列表，作为新的顺序
      const idOrder = this.data.map(item => item.id).filter(id => id);

      if (idOrder.length === 0) {
        message.warning('没有可排序的数据ID');
        return;
      }

      try {
        const res = await SaveCategoryOrder(idOrder); // 调用 POST /sys/club/value/reorder 接口

        if (res.errCode === 0) {
          // message.success('排序已保存'); // 频繁操作可注释
        } else {
          message.error(res.errMsg || '保存排序失败');
          this.search(); // 失败后重新拉取数据，恢复旧顺序
        }
      } catch (error) {
        console.error("SaveCategoryOrder error:", error);
        message.error("请求异常，保存排序失败");
        this.search(); // 失败后重新拉取数据，恢复旧顺序
      }
    },
  },
};
</script>

<style scoped>
.searchArea {
  display: flex;
  margin-bottom: 20px;
}

.thumbnail-wrapper {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.flex_sa {
  display: flex;
  align-items: center;
}

.flex_sa a {
  color: rgba(0, 0, 0, 0.88);
  transition: color 0.3s;
}

.flex_sa a.is-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
  pointer-events: none;
}

.flex_sa .text_danger {
  color: #ff4d4f;
}
</style>